import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import Swal from "sweetalert2/dist/sweetalert2.js";

@Injectable({
  providedIn: "root"
})
export class DataSharingService {
  toggleSettingPanel: Subject<any> = new Subject<any>();
  dashboardBuilderChartData: Subject<any> = new Subject<any>();
  sidebarLogoUrl = "";
  constructor() {}

  DeleteConfirmBox(text) {
    return new Observable<any>((observer) => {
      Swal.fire({
        title: "Are you sure?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        observer.next(result.isConfirmed);
      });
    });
  }
}
